var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDelete({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.738 1.698H.637A.64.64 0 0 0 0 2.335c0 .364.273.637.637.637h15.132a.64.64 0 0 0 .637-.637c0-.364-.304-.637-.668-.637zM2.456 14.465c.06 1.062.97 1.91 2.062 1.91h7.37c1.06 0 1.97-.848 2.061-1.91l.758-10.886H1.698l.758 10.886zm7.854-7.369c0-.182.122-.303.304-.303s.303.121.303.303v5.762c0 .182-.121.303-.303.303s-.304-.121-.304-.303V7.096zM7.884 5.701c0-.182.122-.303.304-.303s.303.121.303.303v8.552c0 .182-.121.303-.303.303s-.304-.121-.304-.303V5.7zM5.458 7.096c0-.182.122-.303.304-.303s.303.121.303.303v5.762c0 .182-.121.303-.303.303s-.304-.121-.304-.303V7.096zM9.673 0H6.702c-.667 0-1.213.485-1.365 1.092h5.701C10.886.485 10.341 0 9.673 0z",
    fill: "#EA4335"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDelete);
export default __webpack_public_path__ + "static/media/delete.37dec30fe0dbcac02d8a3edf6f982307.svg";
export { ForwardRef as ReactComponent };